import React from "react";
import { Route, Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import { UserRole } from "../user/enums/UserRole";
import NotFound from "../pages/NotFound";
import { ManagedStudentsPage } from "./pages/ManagedStudentsPage";
import { ManagedStudentAccountPage } from "./pages/ManagedStudentAccountPage";
import { useAuth } from "../auth/hooks/useAuth";
import { SchoolStudentsPage } from "./pages/SchoolStudentsPage";
import { SchoolStudentAccountPage } from "./pages/SchoolStudentAccountPage";

export function StudentsRoutes({ path }: { path: string }) {
  const { user } = useAuth();

  const StudentsPage = [UserRole.Agent, UserRole.Parent].includes(user?.role)
    ? () => <ManagedStudentsPage userRole={user?.role} />
    : SchoolStudentsPage;

  const StudentPage = [UserRole.Agent, UserRole.Parent].includes(user?.role)
    ? ManagedStudentAccountPage
    : SchoolStudentAccountPage;

  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          path={path}
          roles={[
            UserRole.Owner,
            UserRole.Admin,
            UserRole.Support,
            UserRole.Agent,
            UserRole.Parent,
            UserRole.School,
          ]}
          component={StudentsPage}
        />
        <AuthRoute
          path={`${path}/:studentId`}
          roles={[
            UserRole.Owner,
            UserRole.Admin,
            UserRole.Support,
            UserRole.Agent,
            UserRole.Parent,
            UserRole.School,
          ]}
          component={StudentPage}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
